'use client'

import { PropsWithChildren } from 'react'
import { fromCallback } from 'xstate'

import { FavouritesContext, favouritesMachine } from './FavouritesContext'

const favouritesLocalStorageMachine = favouritesMachine.provide({
  actions: {
    'Write to LocalStorage': ({ context }) => {
      if (context.favourites) {
        localStorage.setItem('favourites', JSON.stringify(context.favourites))
      }
    },
  },
  actors: {
    'Read LocalStorage': fromCallback(({ sendBack }) => {
      const defaultState: string[] = []
      const storedFavourites = localStorage.getItem('favourites')
      const persistedState = (storedFavourites && (JSON.parse(storedFavourites) as string[])) || defaultState
      sendBack({ type: 'Load Current Favourites', favourites: persistedState })
    }),
  },
})

export const FavouritesLocalStorageProvider = ({ children }: PropsWithChildren) => (
  <FavouritesContext.Provider logic={favouritesLocalStorageMachine}>{children}</FavouritesContext.Provider>
)
